// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2446":"f874d1a5","3167":"f874d1a5","5932":"f874d1a5","9441":"ca68bc8a","9705":"f874d1a5"}[chunkId] + ".chunk.css";
};